import React, { useState } from 'react';
import { bool, object, string, node, array } from 'prop-types';
import classNames from 'classnames';
import { LazyComponent } from '@fiverr-private/orca';
import { LoadingGigCardCarousel } from '@fiverr-private/gig_listings';
import GigCardCarouselHOC from '../GigCardCarouselHOC';
import { getSliderConfig, BOTTOM } from './config';

import './style.scss';

const GigCardCarouselWrapper = ({
    boxTitle,
    boxClass,
    boxLocation = BOTTOM,
    showTranslatedUGC = false,
    gigs = [],
    isLoading = true,
    contextEnrichment = {}
}, { logger }) => {
    const [isLazyImportError, setLazyImportError] = useState(false);
    const boxClasses = classNames('gig-card-carousel-wrapper', boxClass);
    const { sliderBaseNum, sliderBreakpoints } = getSliderConfig(boxLocation);

    const lazyImport = () => import(
        /* webpackChunkName: 'GigCardCarousel' */ '../GigCardCarousel'
    );

    const onLazyImportError = (error) => {
        logger.error(error, { description: 'Failed to lazy load GigCardCarousel.' });
        setLazyImportError(true);
    };

    const componentProps = {
        gigs,
        sliderBaseNum,
        sliderBreakpoints,
        isLoading,
        showTranslatedUGC,
        features: { priceFormatting: true },
        lazyLoad: true,
        ...contextEnrichment
    };

    if (isLazyImportError) {
        return null;
    }

    return (
        <div className={boxClasses}>
            <h2 className="section-title">{boxTitle}</h2>
            <LazyComponent componentProps={componentProps}
                lazyImport={lazyImport}
                placeholder={<LoadingGigCardCarousel slidesToShow={sliderBaseNum}
                    sliderBreakpoints={sliderBreakpoints}/>}
                onError={onLazyImportError}/>
        </div>
    );
};

GigCardCarouselWrapper.propTypes = {
    boxClass: string,
    boxLocation: string,
    boxTitle: node,
    showTranslatedUGC: bool,
    gigs: array,
    isLoading: bool,
    contextEnrichment: object
};

GigCardCarouselWrapper.contextTypes = {
    logger: object
};

export { GigCardCarouselWrapper };
export default GigCardCarouselHOC(GigCardCarouselWrapper);
